import { useState, useRef, useEffect } from "react";
import "./selectbox.scss";

export interface Option {
  value: string;
  label: string;
}

interface CustomSelectProps {
  options: Option[];
  onChange: (value: string) => void;
  placeholder?: string;
  selectedMonth?: string;
  resetTrigger?: boolean;
  defaultMonth?: string;
}

const SelectBox = ({
  options,
  onChange,
  resetTrigger,
  selectedMonth,
  placeholder = "Seçiniz",
}: CustomSelectProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<
    Option | null | undefined
  >(null);
  const selectRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option: Option) => {
    setSelectedOption(option);
    onChange(option.value);
    setIsOpen(false);
  };

  useEffect(() => {
    setSelectedOption(null);
  }, [resetTrigger]);

  useEffect(() => {
    if (selectedMonth && selectedMonth !== "0") {
      setSelectedOption(
        options.find((option: Option) => option.value === selectedMonth)
      );
    }
  }, [selectedMonth, options]);

  return (
    <div className="selectbox" ref={selectRef}>
      <div
        className={"selectbox-trigger " + (isOpen ? "active" : "")}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedOption ? selectedOption.label : placeholder}

        <span className="icon icon-arrow-right"></span>
      </div>
      {isOpen && (
        <div className="selectbox-options">
          {options.map((option) => (
            <div
              key={option.value}
              className={
                "selectbox-option " +
                (selectedOption?.label === option.label ? "active" : "")
              }
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectBox;
